export default __webpack_public_path__ + "static/media/add.fc3125ab.svg";